/* 전역 상태 표시 — 로딩/빈상태/에러를 한 곳에 통일(plan §S5-4 "전역 에러/로딩 일관").
   각 feature 가 제각각 만들던 empty-state 마크업을 이 컴포넌트로 모은다.
   순수 표시 컴포넌트(상태·핸들러는 호출부 소유) — 동작은 바꾸지 않는다. */
import { Icon } from '../icons/Icon.jsx';

/* 회전 스피너 (admin.css .spinner). */
export function Spinner({ size = 18, stroke = 2.4, ...rest }) {
  return <span className="spinner" style={{ width: size, height: size, borderWidth: stroke }} role="status" aria-label="불러오는 중" {...rest} />;
}

/* 로딩 자리표시 — 섹션 전체 로딩에 사용. */
export function Loading({ title = '불러오는 중…', sub }) {
  return (
    <div className="empty-state">
      <div className="empty-state__icon"><Spinner size={24} /></div>
      <div className="empty-state__t">{title}</div>
      {sub && <div className="empty-state__d">{sub}</div>}
    </div>
  );
}

/* 빈 상태 — 데이터가 없을 때. action = 선택적 버튼/노드. */
export function EmptyState({ icon = 'folder', title, sub, action }) {
  return (
    <div className="empty-state">
      {icon && <div className="empty-state__icon"><Icon name={icon} size={26} /></div>}
      <div className="empty-state__t">{title}</div>
      {sub && <div className="empty-state__d">{sub}</div>}
      {action && <div style={{ marginTop: 16, display: 'flex', gap: 8, justifyContent: 'center' }}>{action}</div>}
    </div>
  );
}

/* 에러 상태 — error 는 {message,status} 객체 또는 문자열 모두 허용.
   status === 401(인증만료) → '다시 로그인'(onRelogin), 그 외 → '다시 시도'(onRetry).
   메시지 자체는 api/adminApi.js·s3.js 가 이미 통일(401/403/네트워크·CORS 힌트). */
export function ErrorState({ error, onRetry, onRelogin, title = '문제가 발생했습니다' }) {
  const status = error && typeof error === 'object' ? error.status : undefined;
  const message = (error && typeof error === 'object' ? error.message : error) || '알 수 없는 오류가 발생했습니다.';
  const isAuth = status === 401;
  return (
    <div className="empty-state">
      <div className="empty-state__icon"><Icon name="help" size={26} /></div>
      <div className="empty-state__t">{title}</div>
      <div className="empty-state__d">{message}</div>
      {(onRetry || (isAuth && onRelogin)) && (
        <div style={{ marginTop: 18, display: 'flex', gap: 8, justifyContent: 'center' }}>
          {isAuth && onRelogin
            ? <button className="btn btn--primary" onClick={onRelogin}><Icon name="login" size={15} />다시 로그인</button>
            : onRetry && <button className="btn btn--ghost" onClick={onRetry}><Icon name="refresh" size={15} />다시 시도</button>}
        </div>
      )}
    </div>
  );
}
